/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Onl_How_3_DescInputs */

const en_vc_onl_how_3_desc = /** @type {(inputs: Vc_Onl_How_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It uses WebGPU when your browser has it and falls back to WebGL2 automatically. Recent Chrome, Edge, Firefox and Safari all work.`)
};

const zh_vc_onl_how_3_desc = /** @type {(inputs: Vc_Onl_How_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览器支持 WebGPU 时会使用 WebGPU，否则自动切换到 WebGL2。新版 Chrome、Edge、Firefox 和 Safari 都可以用。`)
};

/**
* | output |
* | --- |
* | "It uses WebGPU when your browser has it and falls back to WebGL2 automatically. Recent Chrome, Edge, Firefox and Safari all work." |
*
* @param {Vc_Onl_How_3_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_onl_how_3_desc = /** @type {((inputs?: Vc_Onl_How_3_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Onl_How_3_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_onl_how_3_desc(inputs)
	return zh_vc_onl_how_3_desc(inputs)
});
export { vc_onl_how_3_desc as "vc.onl.how.3.desc" }